import useEstonia from '@/hooks/estonia';

export enum ExpRegExistIntentPopup {
  A = 'exp_reg_dep_exist_intent_popup_a',
  B = 'exp_reg_dep_exist_intent_popup_b',
}

export const LEAVE_REGISTRATION_MODAL_SHOWN = 'leaveRegistrationModalShown';

export const useRegistrationABTExitPopup = () => {
  const { isEstonia } = useEstonia();

  if (isEstonia) return false;

  return false;
};
